module.exports = __webpack_public_path__ + "img/a-philosopher-looks-at-human-beings-cover.9d866f6f.jpg";